import { useTranslation } from 'react-i18next';
import { Dialog } from 'src/components/Dialog';
import { Assessment, UserAssessmentResult } from 'src/models/assessment/_types';

import AssessmentCustomTemplate from './AssessmentCustomTemplate';

interface PreviewDialogProps {
  open: boolean;
  onClose: () => void;
  isResults?: boolean;
  assessment: Assessment;
}

export const PreviewDialog = ({
  open,
  onClose,
  isResults = false,
  assessment,
}: PreviewDialogProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'assessment.new',
  });

  // In preview mode, results is typically an empty array since we're just previewing the template
  // This matches Ember's behavior where result=model.results and results=model.results are passed
  // In Ember, result is truthy when model.results exists (even if empty), which maps to isResults
  const results: UserAssessmentResult[] = [];
  const result = isResults;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('previewDialog.title')}
      maxWidth="lg"
      fullWidth
      actions={[
        {
          label: t('previewDialog.close'),
          onClick: onClose,
          color: 'primary',
          variant: 'prominent',
        },
      ]}
    >
      <AssessmentCustomTemplate
        assessment={assessment}
        result={result}
        results={results}
        offset={0}
      />
    </Dialog>
  );
};
